import React, { useEffect } from 'react';
import { CloseIcon } from '@domain-group/fe-co-icon';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
var promoImage = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-search-results/static/property-alerts-promo_2e511c59.svg";
import * as styles from './onboarding-popup.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var OnboardingPopup = _ref => {
  var onClose = _ref.onClose,
    displayCreatePopup = _ref.displayCreatePopup;
  var containerRef = React.useRef(null);
  useEffect(() => {
    var closePopup = evt => {
      if (containerRef.current && !containerRef.current.contains(evt.target)) {
        onClose === null || onClose === void 0 ? void 0 : onClose();
      }
    };
    document.addEventListener('mousedown', closePopup, false);
    return () => {
      document.removeEventListener('mousedown', closePopup, false);
    };
  }, [onClose]);
  return ___EmotionJSX("div", {
    css: styles.popup,
    ref: containerRef
  }, ___EmotionJSX("button", {
    "aria-label": "close",
    type: "button",
    onClick: onClose,
    css: styles.closeButton
  }, ___EmotionJSX(CloseIcon, {
    size: "small"
  })), ___EmotionJSX("div", {
    css: styles.content
  }, ___EmotionJSX("span", null, ___EmotionJSX("img", {
    src: promoImage,
    width: "80",
    height: "73",
    alt: ""
  })), ___EmotionJSX("div", {
    css: styles.contentMiddle
  }, ___EmotionJSX("div", {
    css: styles.title
  }, "Keep up with this search"), ___EmotionJSX("div", {
    css: styles.message
  }, "Tap the bell and we'll email you when new properties match this search."), ___EmotionJSX("div", {
    css: styles.buttonGroup
  }, ___EmotionJSX(Button, {
    css: styles.button,
    appearance: "ghost",
    onClick: displayCreatePopup
  }, "Try it out")))));
};